// extracted by mini-css-extract-plugin
export default {"link":"NOHEfficiencyTile_link__eCcPr","arrow":"NOHEfficiencyTile_arrow__zJKZb","tileTitle":"NOHEfficiencyTile_tileTitle__gKQ4P"};